import script from "./ProfileActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileActivity.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileActivity.vue?vue&type=style&index=0&id=5555f232&lang=scss"

const __exports__ = script;

export default __exports__